var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMulesoft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1910_11918)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1910_11918)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.7763 2.84766C16.6961 2.84766 2.8479 16.6958 2.8479 33.7761C2.8479 50.8588 16.6961 64.7044 33.7763 64.7044C50.8591 64.7044 64.7047 50.8563 64.7047 33.7761C64.7047 16.6958 50.8565 2.84766 33.7763 2.84766ZM33.7763 5.56678C49.3565 5.56678 61.9856 18.1959 61.9856 33.7761C61.9856 49.3562 49.3565 61.9853 33.7763 61.9853C18.1961 61.9853 5.56702 49.3562 5.56702 33.7761C5.56702 18.1984 18.1961 5.56678 33.7763 5.56678ZM21.74 14.0953C21.74 14.0953 14.0259 18.3402 11.5336 27.6265C9.86607 33.3585 10.5285 39.7452 13.861 45.4464C16.2329 49.4993 19.7844 52.7325 24.0416 54.7146L26.1086 46.8227C21.4668 44.6319 18.093 40.1963 18.093 34.4771C18.0845 31.5976 18.9303 28.7802 20.5235 26.3816L30.1938 41.5004H37.3898L47.0626 26.3816C48.6553 28.7795 49.5011 31.5959 49.4931 34.4745C49.4931 40.1963 46.1219 44.6293 41.48 46.8227L43.5471 54.7146C47.8017 52.733 51.3512 49.5018 53.7225 45.4515C57.0576 39.7478 57.72 33.3585 56.0525 27.6265L56.0576 27.6342C53.5679 18.3479 45.8513 14.1004 45.8513 14.1004L44.9853 15.4587L33.7969 32.9771H33.7892L22.5802 15.4149L21.74 14.0953Z",
    fill: "#F4F4F4"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1910_11918",
    x: -77.1521,
    y: -77.1523,
    width: 221.857,
    height: 221.856,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 40
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0470588 0 0 0 0 0.0784314 0 0 0 0 0.192157 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1910_11918"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1910_11918",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1910_11918"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 68,
    height: 68,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMulesoft);
export default __webpack_public_path__ + "static/media/icon-mulesoft.f979aad846107ed4b0bb0f6ef1874e6a.svg";
export { ForwardRef as ReactComponent };